<div class="wrapper">
    <mat-card>
        <mat-card-title>
            <h2>Basic Info</h2>
        </mat-card-title>
        <mat-card-content>
            <div class="row">
                <div class="col-lg-6">
                    <form [formGroup]="userForm" (ngSubmit)="userFormSubmit()">
                        <div class="row">
                            <div class="col-lg-12">
                                <mat-form-field>
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" />
                                    <mat-error *ngIf="f?.name?.errors?.required">This field is required.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <mat-form-field>
                                    <mat-label>New Password</mat-label>
                                    <input type="password" autocomplete="off" matInput formControlName="new_password" />
                                    <mat-error *ngIf="f?.new_password?.errors?.minlength"> Password must be at least 8 characters long.</mat-error>
                                    <mat-error *ngIf="f?.new_password?.errors?.required">This field is required.</mat-error>

                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <mat-form-field>
                                    <mat-label>Confirm New Password</mat-label>
                                    <input type="password" autocomplete="off" matInput formControlName="confirm_new_password" />
                                    <mat-error *ngIf="f?.confirm_new_password?.errors?.mustMatch">Passwords must match.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 text-center">
                                <button type="submit" mat-raised-button class="btn-int-blue">Update </button>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>